import NVDASwingWidget from '../components/NVDASwingWidget';

export default function NVDASwing() {
  return (
    <div>
      <NVDASwingWidget />
    </div>
  );
}
